// extracted by mini-css-extract-plugin
export default {"typography":"Typography_typography__XZ0z5"};